/* eslint-disable */
import React, { useState, useEffect } from "react";
import { getToken, removeToken } from "../auth/AuthService";
import { useNavigate, useLocation } from "react-router-dom";
import { FaSignOutAlt, FaRegQuestionCircle, FaEye, FaEyeDropper } from "react-icons/fa";
import { useLoader } from "../helper/Loader";
import HelpTour from "../Components/HelpTour";
import { toast } from "react-toastify";

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(false);
  const [startTour, setStartTour] = useState(false);
  const [inspectMode, setInspectMode] = useState(false);

  const { setIsLoader } = useLoader;

  useEffect(() => {
    const tokenExists = !!getToken();
    setLoggedIn(tokenExists);

    if (location.pathname === "/") {
      setLoggedIn(false);
    } else if (tokenExists) {
      setLoggedIn(true);
    }
  }, [location]);

  // Global Inspect Element Mode
  useEffect(() => {
    if (!inspectMode) {
      document.body.style.cursor = 'default';
      return;
    }
    document.body.style.cursor = 'help';
    toast.info('Inspect mode active. Click any tab, button, or link to understand its function!', {
      position: "top-center",
      autoClose: 3000
    });

    const handleWindowClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setInspectMode(false);
      document.body.style.cursor = 'default';

      let target = e.target;
      let text = '';
      
      const findText = (el) => {
        if (!el) return '';
        const textContent = el.textContent || '';
        const classList = el.className || '';
        
        // Sidebar navigation items
        if (el.closest('.vmo-nav-link') || el.closest('.nav-item')) {
          const title = el.closest('a')?.querySelector('.link-text')?.textContent || el.closest('a')?.textContent || 'Sidebar Item';
          return `This is the "${title.trim()}" navigation menu. Clicking it will load that module's dashboard.`;
        }
        
        // Add Button
        if (el.closest('.add-button') || (el.tagName === 'BUTTON' && textContent.toLowerCase().includes('add'))) {
          return 'This button allows you to add or create a new record in this module.';
        }
        
        // Search Button/Input
        if (el.closest('.search-button') || el.tagName === 'INPUT' && el.placeholder?.toLowerCase().includes('search')) {
          return 'Use this search field to type a keyword and filter records in the data table below.';
        }

        // Export Button
        if (el.closest('.export-data') || (el.tagName === 'BUTTON' && textContent.toLowerCase().includes('export'))) {
          return 'Clicking this button exports the currently selected or filtered list data into a CSV spreadsheet file.';
        }

        // View/Edit/Delete in Table
        if (el.closest('.view') || el.closest('.btn-info') || classList.toString().includes('view')) {
          return 'This action opens a detail popup/view to read all details of the selected item.';
        }
        if (el.closest('.edit') || el.closest('.btn-primary') || classList.toString().includes('edit')) {
          return 'This action opens a form editor to modify information for this record.';
        }
        if (el.closest('.delete') || el.closest('.btn-danger') || classList.toString().includes('delete')) {
          return 'This action permanently deletes this record from the database.';
        }

        // Logout
        if (el.closest('.logout')) {
          return 'This button logs you out of the session and returns you to the login screen.';
        }

        // User Tracking dashboard tabs
        if (el.classList.contains('tracking-tab-item')) {
          return `This switches the User Tracking Tool to show the: "${textContent.trim()}" view.`;
        }

        if (el.tagName === 'TH' || el.closest('thead')) {
          return 'This is a table column header. It defines the categories for the table data below.';
        }

        if (el.closest('.pagination') || el.closest('.btn-group') || el.closest('.page-item')) {
          return 'Pagination controls to jump between different pages of results.';
        }

        return '';
      };

      text = findText(target) || findText(target.parentElement) || findText(target.closest('div'));
      
      if (text) {
        toast.info(text, {
          position: "top-center",
          autoClose: 8000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored"
        });
      } else {
        toast.info('This is an interactive dashboard item. Click the "Take Tour" button in the header for a step-by-step tour!', {
          position: "top-center"
        });
      }
    };

    window.addEventListener('click', handleWindowClick, true);
    return () => {
      window.removeEventListener('click', handleWindowClick, true);
      document.body.style.cursor = 'default';
    };
  }, [inspectMode]);

  const handleLogout = () => {
    setStartTour(false);
    removeToken(() => {
      setLoggedIn(false);
    });
    localStorage.clear("loginData");
    navigate("/");
  };

  const handleredirect = () => {
    navigate("/dashboard");
  };

  const handleStartTour = () => {
    setStartTour(true);
  };

  const handleStopTour = () => {
    setStartTour(false);
  };

  return (
    <>
    <div className="header">
      <div className="container-fluid">
        <div className="head-block">
          <div className="logo-image tour-logo">
            <img
              src={require("../images/logo-new.png")}
              onClick={handleredirect}
              alt=""
            />
          </div>
          <div style={{display:"flex", gap: "10px", alignItems: "center", flexWrap: "wrap", justifyContent: "center"}}>
            {loggedIn && (
              <>
                <button 
                  onClick={() => setInspectMode(!inspectMode)} 
                  className={`login-button btn btn-sm ${inspectMode ? 'btn-danger' : 'btn-outline-primary'}`} 
                  style={{display: "flex", alignItems: "center", gap: "6px", borderRadius: "15px", height: "38px", border: "1px solid rgba(82, 108, 254, 0.3)"}}
                >
                  <FaEyeDropper style={{fontSize: "14px"}} />
                  {inspectMode ? 'Exit Inspect' : 'What is this?'}
                </button>
                <button 
                  onClick={handleStartTour} 
                  className="login-button btn btn-sm btn-primary" 
                  style={{display: "flex", alignItems: "center", gap: "6px", borderRadius: "15px", height: "38px", background: "linear-gradient(135deg, #526cfe 0%, #530cb3 100%)", border: "none", color: "#fff"}}
                >
                  <FaRegQuestionCircle style={{fontSize: "14px"}} />
                  Take Tour
                </button>
              </>
            )}

            {loggedIn && (
              <div className="login-button logout" style={{display: "flex", alignItems: "center", justifyContent: "center", borderRadius:"15px"}} onClick={handleLogout}>
                <FaSignOutAlt style={{fontSize: "20px"}}  />
                Log Out
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    {startTour && (
      <HelpTour start={startTour} setStartTour={setStartTour} onStopTour={handleStopTour}/>
    )}
    </>
  );
}
